import logo from './grimace.png';
import './App.css';
import Navigation from './components/Navigation.tsx';
import Sidebar from './components/Sidebar.tsx';
import PageContainer from './components/PageContainer.tsx';
import HomePage from './pages/HomePage.tsx';

function App() {
  return (
    <>
      <Navigation />
      <Sidebar />
      <div className="App">
        <PageContainer {...<HomePage />} />
      </div>
    </>
  );
}

export default App;
